import React from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default function ContactSection() {
  return (
    <Box id="contact" sx={{ 
      minHeight: '50vh', 
      py: 12, 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      background: 'var(--white)'
    }}>
      <Typography variant="h3" fontWeight={700} sx={{ color: 'var(--rosewood)', mb: 3 }}>
        Get In Touch
      </Typography>
      <Typography align="center" sx={{ color: 'var(--chinese-violet)', fontSize: '1.1rem', maxWidth: 600, mb: 6, px: 2, lineHeight: 1.6 }}>
        I'm always open to discussing new projects, creative ideas, or opportunities to be part of your visions.
      </Typography>
      
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} sx={{ mb: 8, width: { xs: '100%', sm: 'auto' }, alignItems: 'center', px: 2 }}>
        <Button 
          variant="contained" 
          href="mailto:sidd.kumaran@gmail.com" 
	  onClick={(e) => {
		e.preventDefault();
		window.location.href = "mailto:sidd.kumaran@gmail.com";
	  }}
          sx={{ 
            fontWeight: 700,
            background: 'var(--madder)',
            color: 'var(--white)',
            px: 4,
            py: 1.5,
            borderRadius: '6px',
            textTransform: 'none',
            fontSize: '1rem',
            boxShadow: 'none',
            '&:hover': {
              background: 'var(--crimson)',
              boxShadow: 'none'
            }
          }}
        >
          Send Email
        </Button>
        <Button 
          variant="outlined" 
          href="https://www.linkedin.com/in/sid-kumaran/" 
          target="_blank" 
          sx={{ 
            fontWeight: 700,
            borderColor: 'var(--pacific-cyan)',
            color: 'var(--pacific-cyan)',
            px: 4,
            py: 1.5,
            borderRadius: '6px',
            textTransform: 'none',
            fontSize: '1rem',
            borderWidth: '2px',
            '&:hover': {
              borderColor: 'var(--pacific-cyan)',
              background: 'rgba(75, 163, 195, 0.05)',
              borderWidth: '2px'
            }
          }}
        >
          LinkedIn
        </Button>
        <Button 
          variant="text" 
          href="/theater" 
          sx={{ 
            fontWeight: 600,
            color: 'var(--chinese-violet)',
            px: 3,
            py: 1.5,
            borderRadius: '6px',
            textTransform: 'none',
            fontSize: '1rem',
            '&:hover': {
              background: 'rgba(131, 107, 137, 0.1)',
              color: 'var(--rosewood)'
            }
          }}
        >
          Book Theater Seats
        </Button>
      </Stack>

      <Box sx={{ mt: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', opacity: 0.7, transition: 'opacity 0.2s', '&:hover': { opacity: 1 } }}
        onClick={() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
        aria-label="Scroll to Top"
      >
        <Typography variant="caption" sx={{ color: 'var(--chinese-violet)', mb: 1, fontWeight: 600 }}>BACK TO TOP</Typography>
        <KeyboardArrowDownIcon
          sx={{
            fontSize: 32,
            color: 'var(--rosewood)',
            transform: 'rotate(180deg)'
          }}
        />
      </Box>
    </Box>
  );
}
